import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RoyaltyButtonService } from "./button.service";
import { MatButtonModule } from "@angular/material/button";
import { SharedModule } from "@royalty/module";
import { RoyaltyButtonComponent } from "./button.component";

@NgModule({
	imports: [MatButtonModule, SharedModule],
	exports: [RoyaltyButtonComponent],
	declarations: [RoyaltyButtonComponent],
	providers: [RoyaltyButtonService],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RoyaltyButtonModule {}
